<template>
    <div>
        <div class="treetitle">
            <div class="tree-header-left">
                <img src="../assets/icon_level.svg" style="height:15px;vertical-align:middle"/>
                <span v-t="'message.item_layerId'"></span>
            </div>
        </div>
        <el-tree v-if="show"
                 class="common-object-tree"
                 :props="properties"
                 :load="loadNode"
                 node-key="id"
                 ref="tree"
                 lazy
                 highlight-current
                 default-expanded-keys="{1}"
                 :expand-on-click-node="false"
                 @node-click="handleNodeClick"
                 :render-content="renderContent">
        </el-tree>
        <div v-else style="height:calc(100vh - 232px);overflow-y:auto">
            <div class="foundObject-record" v-for="object in foundObjectList" @click="$emit('on-selectnode', object)">
                <div class="foundObject">
                    <img v-if="isAdminUser(object)" src="../assets/admin_user.svg"
                         style="height:20px;vertical-align:middle"></img>
                    <img v-else-if="isFindUser()" src="../assets/user.svg"
                         style="height:20px;vertical-align:middle"></img>
                    <img v-else src="../assets/group.svg" style="height:20px;vertical-align:middle"></img>
                    <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            show: true,
            loadingScreen: null,
            condition: "userId",
            searchString: null,
            listType: 0,
            foundObjectList: [],
            properties: {
                label: 'label',
                isLeaf: 'isLeaf',
            },
            // 初回ロード後に自動選択を一度だけ行うためのフラグ
            autoSelectedOnce: false,
        };
    },
    props: {
        initialData: Object,
        selectedNode: Object,
        talkgroupExpantion: {
            type: Boolean,
            default: false
        },
        showNodeObject: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleNodeClick(data, node, elNode) {
            if (node.data.type == constants.OBJECT_TALKGROUP && this.talkgroupExpantion == true) {
                if (node.childNodes.length == 0) {
                    this.loadingScreen = this.$loading({
                        lock: true,
                        text: 'Loading data ...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0)'
                    });
                    let self = this;
                    let userDataList = [];
                    server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                        .then((res) => {
                            switch (res.data.status) {
                                case constants.STATUS_SUCCESS:
                                    userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                                    break;
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_expand_layer_denied"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "handleNodeClick").replace("{code}", res.data.status));
                                    break;
                            }
                            if (data.length == 0) {
                                node.loading = true;
                                node.isLeaf = true;
                                node.data.isLeaf = true;
                            } else {
                                for (let index = 0; index < userDataList.length; index++) {
                                    if (index == 0) {
                                        self.$refs.tree.append(userDataList[index], node);
                                    } else {
                                        self.$refs.tree.insertAfter(userDataList[index], node.childNodes[index - 1]);
                                    }
                                }
                            }
                            self.closeLoadingScreen();
                            self.$emit('on-selectnode', elNode)
                        })
                        .catch(function (error) {
                            self.closeLoadingScreen();
                            commonUtil.putExceptionErrorMessage(self, "handleNodeClick", error);
                        });
                } else {
                    this.$emit('on-selectnode', elNode)
                }
            } else {
                this.$emit('on-selectnode', elNode)
            }
        },
        handleChangeSearchCondition() {
            this.foundObjectList = [];
            return;
        },
        reload() {
            if (this.listType == 0) {
                this.show = false;
                this.$nextTick(() => {
                    this.show = true
                })
            } else {
                this.findObject();
            }
        },
        autoSelectFirstRoot() {
            try {
                if (this.autoSelectedOnce) return;
                const tree = this.$refs.tree;
                if (!tree) return;
                // ルート直下の最上位ノード（テナントや最上位ノード）を選択
                const roots = this.initialData || [];
                if (!Array.isArray(roots) || roots.length === 0) return;
                const first = roots[0];
                if (!first || first.id == null) return;

                // Element-UI の選択状態更新
                if (typeof tree.setCurrentKey === 'function') {
                    tree.setCurrentKey(first.id);
                }
                const treeNode = typeof tree.getNode === 'function' ? tree.getNode(first.id) : null;

                // User.vue 側の `selectedNode.node.data` アクセスに合わせるために `node` プロパティで包む
                const payload = treeNode ? { node: treeNode } : null;
                if (payload) {
                    this.autoSelectedOnce = true;
                    this.$emit('on-selectnode', payload);
                }
            } catch (e) {
                // 失敗時は何もしない
            }
        },
        loadNode(node, resolve) {
            if (node.parent == null) {
                if (this.initialData && this.initialData.length > 0) {
                    resolve(this.initialData);
                } else {
                    resolve([]);
                }
                return;
            }

            let self = this;

            this.loadingScreen = this.$loading({
                lock: true,
                text: 'Loading data ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });

            if (node.data.type == constants.OBJECT_TALKGROUP && this.talkgroupExpantion == true) {
                server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                    .then((res) => {
                        if (res.data.status >= 0) {
                            let userDataList = [];
                            userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                            resolve(userDataList);
                        } else {
                            switch (res.data.status) {
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_expand_layer_denied"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "loadNode-1").replace("{code}", res.data.status));
                                    break;
                            }
                            node.loading = false;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        }
                        self.closeLoadingScreen();
                    })
                    .catch(function (error) {
                        self.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    });

                return;
            }

            server.post('/getchildrennodeonly', {tenantId: node.data.tenantId, parentId: node.data.id})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let data = [];
                        if (self.showNodeObject) {
                            for (let i = 0; i < res.data.nodeInfo.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.nodeInfo[i].id,
                                    label: res.data.nodeInfo[i].name,
                                    type: res.data.nodeInfo[i].type,
                                    isLeaf: res.data.nodeInfo[i].hasChild == 0 ? true : false   // TODO: ここのロジックを変更する。hasChildではなく、Nodeが下についているかで判断
                                });
                            }
                        }

                        let typeOrder = commonUtil.getObjectTreeTypeOrder();
                        data = data.sort(function (e1, e2) {
                            let orderResult = typeOrder[e1.type] - typeOrder[e2.type]
                            if (orderResult !== 0) {
                                return orderResult;
                            } else {
                                let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                if (comparisonResult < 0) return -1;
                                else if (comparisonResult > 0) return 1;
                            }
                            return 0;
                        });

                        resolve(data)

                        // 初期ロード直後に最上位ノードを自動選択（初回のみ）
                        if (!this.autoSelectedOnce) {
                            this.$nextTick(() => {
                                this.autoSelectFirstRoot();
                            });
                        }
                    } else {
                        switch (res.data.status) {
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_expand_layer_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "loadNode-2").replace("{code}", res.data.status));
                                break;
                        }
                        node.loading = false;
                        node.isLeaf = true;
                        node.data.isLeaf = true;
                    }
                    self.closeLoadingScreen();
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    self.closeLoadingScreen();
                });
        },
        renderContent(h, {node, data, store}) {
            if (data.type !== constants.OBJECT_NODE) {
                return
            }

            let objectIcon = "";
            if (data.id === 1) {
                objectIcon = require("../assets/icon_tenant.svg");
            } else {
                objectIcon = require("../assets/icon_level.svg");
            }

            return h("span", [h("img", {
                attrs: {
                    src: objectIcon,
                    height: "20px",
                    style: "vertical-align: middle"
                }
            }), h("span", node.label)]);
        },
        addGroup: function (selectedNode, input) {
            let self = this;
            server.post(
                '/createnode',
                {
                    operation:
                        {
                            parentId: selectedNode.node.data.id,
                            name: input.name,
                            acl: input.acl,
                            clientSettingId: input.clientSettingId
                        }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_created_layer"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_create_node_denied"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_layer_duplicate"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "addGroup").replace("{code}", res.data.status));
                            break;
                    }
                    return;
                }

                var insertData = {
                    data:
                        {
                            tenantId: selectedNode.node.data.tenantId,
                            id: res.data.createdId,
                            label: input.name,
                            type: 0,
                            isLeaf: true
                        }
                };
                var insertIndex = this.getInsertIndexOfNode(selectedNode.node, input.name);

                this.insertNode(selectedNode.node, insertData, insertIndex)
            })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "addGroup", error);
                });
        },

        insertNode (node, addNode, index) {
            if (index < 0) {
                node.insertBefore(addNode, node.childNodes[0]);
            } else {
                node.insertAfter(addNode, node.childNodes[index]);
            }

            if ((!node.isLeaf) && (!node.loaded)) {
                node.expand(() => {
                    node.loaded = true;
                });
            } else {
                node.expand();
            }
        },

        getInsertIndexOfNode: function (parentNode, insertObjectName) {
            let insertIndex = -1;
            for (let i = 0; i < parentNode.childNodes.length; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            return insertIndex;
        },
        resetCurrentNode(forceReset) {
            if ((typeof this.$refs.tree.currentNodeKey != "undefined") || (forceReset)) {
                this.$refs.tree.setCurrentKey(null);
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        getTalkerListNodeData(nodeData) {
            let data = [];
            for (let i = 0; i < nodeData.length; i++) {
                data.push({
                    tenantId: nodeData[i].tenantId,
                    id: nodeData[i].id,
                    label: nodeData[i].name + " / " + nodeData[i].displayName,
                    type: constants.OBJECT_USER,
                    markerIcon: nodeData[i].markerIcon,
                    displayName: nodeData[i].displayName,
                    isLeaf: true
                })
            }
            data.sort(function (e1, e2) {
                if (e1.type < e2.type) return -1;
                else if (e1.type > e2.type) return 1;
                else {
                    let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                    if (comparisonResult < 0) return -1;
                    else if (comparisonResult > 0) return 1;
                }
                return 0;
            });
            return data;
        },
        findObject() {
            let param = {tenantId: this.initialData[0].tenantId}
            let postUrl;
            switch (this.condition) {
                case "userId":
                case "userName":
                case "organization":
                case "title":
                case "phone":
                    if (this.condition == "userId") {
                        param.name = this.searchString;
                    } else if (this.condition == "userName") {
                        param.displayName = this.searchString;
                    } else if (this.condition == "organization") {
                        if (this.searchString != "") {
                            param.organization = this.searchString;
                        }
                    } else if (this.condition == "title") {
                        if (this.searchString != "") {
                            param.title = this.searchString;
                        }
                    } else if (this.condition == "phone") {
                        if (this.searchString != "") {
                            param.phone = this.searchString;
                        }
                    }
                    postUrl = "/finduser";
                    break;
                case "groupId":
                case "groupName":
                    if (this.condition == "groupId") {
                        param.name = this.searchString;
                    } else if (this.condition == "groupName") {
                        param.displayName = this.searchString;
                    }
                    postUrl = "/findgroup";
                    break;
            }
            let self = this;
            server.post(postUrl, param)
                .then((res) => {
                    let resultData;
                    let resultDataType;
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        if (postUrl == "/finduser") {
                            resultData = res.data.userInfo;
                            resultDataType = constants.OBJECT_USER;
                        } else {
                            resultData = res.data.groupInfo;
                            resultDataType = constants.OBJECT_TALKGROUP;
                        }
                        if (resultData.length == 0) {
                            self.foundObjectList = [];
                            if (resultDataType == constants.OBJECT_USER) {
                                commonUtil.notifyMessage(self, "Info", commonUtil.getMessageText(self.$i18n, "info_user_not_found"));
                            } else {
                                commonUtil.notifyMessage(self, "Info", commonUtil.getMessageText(self.$i18n, "info_group_not_found"));
                            }
                            return;
                        }
                    } else {
                        self.foundObjectList = [];
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "findObject").replace("{code}", res.data.status));
                        return;
                    }
                    self.foundObjectList = [];
                    for (let objectInfo of resultData) {
                        let object = {node: {data: null, parent: {data: null}}}
                        let label;
                        let dataType
                        if (resultDataType == constants.OBJECT_USER) {
                            label = objectInfo.name + " / " + objectInfo.displayName
                            dataType = objectInfo.type;
                        } else {
                            label = objectInfo.name
                            dataType = resultDataType;
                        }
                        object.node.data = {
                            tenantId: self.initialData[0].tenantId,
                            type: dataType,
                            id: objectInfo.id,
                            name: objectInfo.name,
                            displayName: objectInfo.displayName,
                            restrictions: objectInfo.restrictions,
                            label: label
                        };
                        object.node.parent.data = {id: objectInfo.pid}
                        self.foundObjectList.push(object);
                    }
                    self.foundObjectList.sort(function (o1, o2) {
                        let e1 = o1.node.data;
                        let e2 = o2.node.data;
                        if (e1.type < e2.type) return -1;
                        else if (e1.type > e2.type) return 1;
                        else {
                            let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                            if (comparisonResult < 0) return -1;
                            else if (comparisonResult > 0) return 1;
                        }
                        return 0;
                    });
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "findObject", error);
                    self.foundObjectList = [];
                });
        },
        isAdminUser(object) {
            return object.node.data.restrictions != null && object.node.data.restrictions.includes(constants.RESTRICTION_LOGIN);
        },
        isFindUser() {
            switch (this.condition) {
                case "userId":
                case "userName":
                case "organization":
                case "title":
                case "phone":
                    return true;
                case "groupId":
                case "groupName":
                    return false;
            }
        },
        getNodeById(id) {
            return this.$refs.tree.getNode(id);
        }
    },
    updated: function () {
    },
    watch: {
        listType(value) {
            if (value == 1) {
                this.$emit('changeListType', this.listType)
                if (this.listType == 1) {
                    this.foundObjectList = [];
                    this.searchString = null;
                    this.condition = "userId";
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}

.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}

.el-tree-node__content {
    height: 40px !important;
}

.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}

.el-tree-node__expand-icon {
    padding: 28px !important;
}

</style>

<style scoped>

.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}

.tree-command-text:hover {
    opacity: 0.7;
}

button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}

.tree-header-left {
    vertical-align: middle;
    padding-top: 12px;
    padding-left: 20px;
    float: left;
}

.tree-header-right {
    text-align: right;
    vertical-align: middle;
    padding-top: 2px;
    padding-bottom: 3px;
    padding-right: 20px;
}

.treetitle {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 42px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
    min-width: 630px;
}

.modal-default-button {
    float: right;
}

.el-select-dropdown__item {
    font-size: 12px;
}

.el-select-dropdown__item selected {
    color: #5171cb;
}

.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}

.common-object-tree.el-tree {
    width: 100%;
    height: calc(100vh - 175px);
}
</style>
